<template>
    <div class="p-0" v-if="show">
        <div class="row d-flex justify-content-center">
            <div class="my-3 text-center pointer" @click="edit()">
                <i class="far fa-sticky-note big-icon"></i>
                <div class="small mt-3">新規ノート追加</div>
            </div>
        </div>
        <div class="row" v-if="notes">
            <div class="col-lg-4 pointer pt-2" v-for="n in notes.data" :key="n.id">
                <router-link :to="`/mypage/notes/edit/${n.id}`" class="block-link">
                    <div class="card h-100" :class="{'selected-card': n.id === note_id}">
                        <div class="card-header">{{n.caption}}</div>
                        <div class="card-body">
                            <p class="small" v-html="$filters.editorTruncate(n.memo, 240)"></p>
                        </div>
                        <div class="card-footer small text-right">
                            {{$filters.dateFormat(n.updated_at)}}
                        </div>
                    </div>
                </router-link>
            </div>
        </div>
        <note-modal
            :note_id="note_id"
            @saved="startEdit($event)"></note-modal>
        <loading
            v-model:active="isLoading"
            :can-cancel="false"
            :is-full-page="true"></loading>
    </div>
</template>

<style scoped lang="scss">
.selected-card {
    box-shadow: 0 0 7px rgba(17, 17, 190, 0.4);
}
.big-icon {
    font-size: 6rem;
}
.pointer:hover {
    opacity: .8;
}
.block-link {
    &:hover {
        text-decoration: none;
    }
}
</style>

<script>
import page from "components/Page";
import noteModal from "./noteModal";
export default {
    components: {
        page,
        noteModal
    },
    data() {
        return {
            notes: null,
            page: 1,
            note_id: null,
            isLoading: false,
            show: false,
        }
    },
    methods: {
        reload() {
            this.page = 1;
            setTimeout(() => this.load());
        },
        load() {
            this.isLoading = true;
            axios.get("/mypage/book/notes", {params: {page: this.page}}).then(res => {
                if (this.page > 1) {
                    for (const note of res.data.data) {
                        this.notes.data.push(note);
                    }
                    this.notes.current_page = this.page;
                } else {
                    $("html,body").animate({scrollTop: 0}, 300);
                    this.notes = res.data;
                }
                this.isLoading = false;
                this.show = true;
            }).catch(err => { alert.err(err.response) });
        },
        edit() {
            setTimeout(() => {
                $("#note-modal").modal();
            });
        },
        onScroll(ev) {
            let elm = document.documentElement;
            let bottom = elm.scrollHeight - elm.clientHeight;
            if (bottom > 0 && bottom <= window.scrollY) {
                if (this.notes.current_page < this.notes.last_page && this.notes.current_page == this.page) {
                    this.page++;
                    setTimeout(() => this.load());
                }
            }
        },
        startEdit(ev) {
            this.$router.push("/mypage/notes/edit/" + ev);
        }
    },
    mounted() {
        this.load();
        document.querySelector("body").onscroll = this.onScroll;
    },
    destroyed() {
        document.querySelector("body").onscroll = null;
    }
}
</script>